import {
    Box,
    Grid,
    TextField,
    Typography,
    MenuItem,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { IProdutoFormData } from ".";
import SelectUnidadeMedida from "../../../../../components/SelectsSimpleApiQuery/SelectUnidadeMedida";

export default function Step02() {
    const { control, formState: { errors } } = useFormContext<IProdutoFormData>();

    return (
        <Box sx={{ py: 2 }}>
            <Typography variant="h6" gutterBottom>
                Especificações Técnicas
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Defina as características técnicas e especificações detalhadas do produto.
            </Typography>

            <Grid container spacing={2}>

                <Grid size={{ xs: 12, md: 4 }}>
                    <Controller
                        control={control}
                        name="especificacoes.tipo"
                        rules={{ required: "Tipo é obrigatório" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label="Tipo"
                                fullWidth
                                required
                                error={!!errors.especificacoes?.tipo}
                                helperText={errors.especificacoes?.tipo?.message}
                            >
                                <MenuItem value="P">Produto</MenuItem>
                                <MenuItem value="S">Serviço</MenuItem>
                                <MenuItem value="I">Ativo Imobilizado</MenuItem>
                                <MenuItem value="C">Consumo</MenuItem>
                                <MenuItem value="T">Produto Terceiro</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>
                    <Controller
                        control={control}
                        name="especificacoes.unidade_medida"
                        rules={{ required: "Unidade é obrigatória" }}
                        render={({ field }) => (
                            <SelectUnidadeMedida
                                value={Array.isArray(field.value) ? field.value : field.value ? [field.value] : null}
                                onChange={field.onChange}
                                required
                                error={!!errors.informacoesBasicas?.setor}
                                multiple={false}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>
                    <Controller
                        control={control}
                        name="especificacoes.permiteDecimais"
                        rules={{ required: "Campo obrigatório" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label="Permite Decimais?"
                                fullWidth
                                required
                                error={!!errors.especificacoes?.permiteDecimais}
                                helperText={errors.especificacoes?.permiteDecimais?.message}
                            >
                                <MenuItem value="S">Sim</MenuItem>
                                <MenuItem value="N">Não</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <Controller
                        control={control}
                        name="especificacoes.unidadePadraoEtiqueta"
                        render={({ field }) => (
                            <SelectUnidadeMedida
                                label="Unidade padrão etiqueta"
                                value={Array.isArray(field.value) ? field.value : field.value ? [field.value] : null}
                                onChange={field.onChange}
                                error={!!errors.informacoesBasicas?.setor}
                                multiple={false}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <Controller
                        control={control}
                        name="especificacoes.quantidadePadraoEtiqueta"
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="Quantidade Unidade Padrão"
                                type="number"
                                fullWidth
                                slotProps={{ htmlInput: { step: "0.001" } }}
                                error={!!errors.especificacoes?.quantidadePadraoEtiqueta}
                                helperText={errors.especificacoes?.quantidadePadraoEtiqueta?.message}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <Controller
                        control={control}
                        name="especificacoes.unidadeFatorConversao"
                        render={({ field }) => (
                            <SelectUnidadeMedida
                                label="Unidade fator conversão"
                                value={Array.isArray(field.value) ? field.value : field.value ? [field.value] : null}
                                onChange={field.onChange}
                                error={!!errors.informacoesBasicas?.setor}
                                multiple={false}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <Controller
                        control={control}
                        name="especificacoes.quantidadeFatorConversao"
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="Quantidade Fator Conversão"
                                type="number"
                                fullWidth
                                slotProps={{ htmlInput: { step: "0.00001" } }}
                                error={!!errors.especificacoes?.quantidadeFatorConversao}
                                helperText={errors.especificacoes?.quantidadeFatorConversao?.message}
                            />
                        )}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}